// extracted by mini-css-extract-plugin
export default {"title":"receipt_title__QyUm2","receipt":"receipt_receipt__J7zkZ","buttons":"receipt_buttons__yiq72"};